import type { ComponentProps, FC } from 'react';
import {
    Card,
    CardGroup,
    FormField,
    SkeletonLine,
    TextInput,
} from '@george-labs.com/design-system';

import { ConditionalWrapper } from '@luna/utils-ui';

const DEFAULT_NUMBER_OF_FIELDS = 6;
const DEFAULT_COLUMN_WIDTH = 6;

type FormVariant = ComponentProps<typeof FormField>['variant'];
interface Props {
    className?: string;
    numberOfFields?: number;
    labelColumnWidth?: ComponentProps<typeof FormField>['labelColumnWidth'];
    variant?: `${FormVariant}`;
    wrapWithCardGroup?: boolean;
    wrapWithCard?: boolean;
    'data-cy'?: string;
}

export const FormSkeleton: FC<Props> = ({
    className,
    numberOfFields = DEFAULT_NUMBER_OF_FIELDS,
    labelColumnWidth = DEFAULT_COLUMN_WIDTH,
    variant = FormField.VARIANT.DEFAULT,
    wrapWithCardGroup = true,
    wrapWithCard = true,
    'data-cy': dataCy,
}) => (
    <ConditionalWrapper
        condition={wrapWithCardGroup}
        wrapper={CardGroup}
        wrapperProps={{ className }}
    >
        <ConditionalWrapper condition={wrapWithCard} wrapper={Card} data-cy={dataCy}>
            {[...Array(numberOfFields).keys()].map((formFieldItem) => (
                <FormField
                    required
                    key={`form-skeleton-form-field-${formFieldItem}`}
                    label={<SkeletonLine level={3} animated />}
                    input={TextInput}
                    disabled
                    labelColumnWidth={labelColumnWidth}
                    variant={variant as FormVariant}
                    data-cy={`${dataCy ?? 'form-skeleton-form-field'}-${formFieldItem}`}
                />
            ))}
        </ConditionalWrapper>
    </ConditionalWrapper>
);
